import './Privacy.css'


function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy for LunaPlane</h1>
      <p className="effective-date">Effective Date: April 15, 2026</p>

      <p>
        LunaPlane we value your privacy. This Privacy
        Policy explains how we collect, use, and protect your personal
        information when you use LunaPlane.
      </p>

      <div className="privacy-section">
        <h3>1. Information We Collect</h3>

        <p>We collect the following types of personal data:</p>

        <p>
          <span>Account Data:</span> Name, email address, phone number,
          profile information (such as your display name and profile picture).
        </p>

        <p>
          <span>Location Data:</span> GPS-based location (only with your
          consent) to help connect you to local services.
        </p>

        <p>
          <span>Usage Data:</span> Device type, operating system, app usage
          patterns, and crash logs.
        </p>
      </div>

      <div className="privacy-section">
        <h3>2. How We Use Your Information</h3>

        <p>We use your data to:</p>

        <p>Provide and personalize services.</p>
        <p>
          Connect you with local wellness guides, companions, and tour guides.
        </p>
        <p>Process bookings and payments securely.</p>
        <p>
          Improve our services, troubleshoot issues, and analyze trends.
        </p>
        <p>
          Communicate with you about updates, bookings, and support.
        </p>
      </div>

      <div className="privacy-section">
        <h3>3. Location Data</h3>

        <p>
          If you grant permission, we collect GPS-based location data solely to
          assign you to relevant local services. We do not store precise GPS
          coordinates, and you can disable location access at any time.
        </p>
      </div>

      <div className="privacy-section">
        <h3>4. How We Share Your Information</h3>

        <p>
          We do not sell or rent your personal data. We may share information:
        </p>

        <p>
          With trusted service providers who help us operate the webapp (they
          are bound by confidentiality).
        </p>

        <p>
          When required by law or to protect our users.
        </p>
      </div>

      <div className="privacy-section">
        <h3>5. Data Security</h3>

        <p>We implement industry-standard security measures:</p>

        <p>Encryption in transit.</p>
        <p>Secure authentication methods.</p>
        <p>
          Limited access to your personal data by authorized personnel only.
        </p>

        <p>
          We cannot guarantee 100% security, but we take all reasonable
          precautions.
        </p>
      </div>

      <div className="privacy-section">
        <h3>6. Your Rights and Choices</h3>

        <p>You have the right to:</p>

        <p>Access, update, or delete your personal information.</p>
        <p>Revoke location permissions anytime.</p>
        <p>Request account deletion by contacting us.</p>
      </div>

      <div className="privacy-section">
        <h3>7. Children’s Privacy</h3>

        <p>
          LunaPlane is not intended for children under 13. We do not knowingly
          collect information from children. If we discover such data, we will
          delete it promptly.
        </p>
      </div>

      <div className="privacy-section">
        <h3>8. Third-Party Links</h3>

        <p>
          Our webapp may contain links to third-party websites or services. We
          are not responsible for their privacy practices.
        </p>
      </div>

      <div className="privacy-section">
        <h3>9. Policy Updates</h3>

        <p>
          We may update this Privacy Policy periodically. We will post changes
          here with a new effective date. Continued use means you accept the
          revised policy.
        </p>
      </div>

      <div className="privacy-section">
        <h3>10. Contact Us</h3>

        <p>
          If you have questions or concerns, please contact us at:
        </p>

        <p>
          Email:{" "}
          <a href="mailto:info@lunaplane.com">
            info@lunaplane.com
          </a>
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;